






























































































































































import axios from "axios"
import {Component, Prop, Vue} from 'vue-property-decorator';
import DropDown from "./Dropdown.vue";

const TextHighlight = require('vue-text-highlight').default;

Vue.component('text-highlight', TextHighlight);
Vue.use(TextHighlight);


@Component({
  components: {
    DropDown
  }
})
export default class JobDescription extends Vue {

  @Prop() private msg!: string;
  jobDescription: any = [];
  // video: string = '';

  isLoading: boolean = true;
  icon: any = [];
  count: any = 0;
  jobId: string = ''

  queries: Array<any> = [];


  // async mounted() {
  //     // this.location = this.location ? this.location.containsEncodedComponents: "null"
  //
  //     let urlParams = new URLSearchParams(window.location.search);
  //     let myParam = urlParams.get('department')
  //      console.log(myParam,'test98')
  //
  //     this.location = this.location ? decodeURIComponent(this.location): "null"
  //     this.department = this.department ? decodeURIComponent(this.department): "null"
  //     // this.location = this.location ? this.location.replace("%2C+", ", ").replace("+-+", " - ") : "null"
  //     // this.department = this.department ? this.department.replace("%2F", "/").replace("%26", "&").replace("%20", " ").replace("+", " ").replace("+%26+"," & ").replace("+%2F+"," / ") : "null"
  //     console.log(this.department,'depar')
  //    this.location ==='Remote'?await this.listRemoteJobs():await this.listJobs()
  // }

  async mounted() {

    const script = document.createElement('script');
    script.src = 'https://widget.altrulabs.com/main.js';
    script.setAttribute('data-altru-widget-id', '12012990');
    script.setAttribute('data-altru-global-region', 'us');
    document.body.appendChild(script);
    // this.location = this.location ? this.location.containsEncodedComponents: "null"
    // let url = new URLSearchParams(window.location.search);

    let url = window.location.href
    // let jobId = url.get('postId')
    if (url.includes("opening-description")) {
      let splitList = url.split('/').reverse()

      this.jobId = splitList[0] !== "" ? splitList[0] : splitList[1]


      await this.getJobDescription(this.jobId)
    }

  }

  async getJobDescription(jobId: string | null) {

      await axios.get(`https://api.lever.co/v0/postings/rackspace/${jobId}`)
          .then(((jobRes) => {
           this.isLoading = false
            this.jobDescription = jobRes.data;


            // this.video = "https://app.altrulabs.com/embed/12825770";
            // console.log(this.video, "video")
            // this.jd= jobRes.data.description.replace(/<br\s*\/?>/gi,' ');


          })).catch(e => console.log(e))

  }

  sendToLever() {
    location.href = `https://jobs.lever.co/rackspace/${this.jobId}/apply`;
  }


  getQueryString(field: any, url: any) {
    let href = url ? url : window.location.href;
    let reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
    let string = reg.exec(href);
    return string ? string[1] : null;
  }


  // filteredJobs(data: any) {
  //     this.JobPostings = data
  //     this.isLoading = false;
  // }


}

